// Auto-bundled locale chunk for en. Loaded on demand by I18nProvider.
import r0 from '../locales/en/auth_login.json';
import r1 from '../locales/en/auth_signup.json';
import r2 from '../locales/en/lobby_home.json';
import r3 from '../locales/en/table_ingame.json';
import r4 from '../locales/en/common.json';
import r5 from '../locales/en/cashier.json';
import r6 from '../locales/en/lounge.json';
import r7 from '../locales/en/profile.json';
import r8 from '../locales/en/mobile_lobby.json';
import r9 from '../locales/en/mobile_social.json';
import r10 from '../locales/en/electron.json';
import r11 from '../locales/en/multitable.json';
import r12 from '../locales/en/translation_completion.json';
import r13 from '../locales/en/phase1_east_asia.json';

import welcomePopupLocale from '../locales/en/welcome_popup.json';

const bundle = {
  ...welcomePopupLocale,
  ...r0,
  ...r1,
  ...r2,
  ...r3,
  ...r4,
  ...r5,
  ...r6,
  ...r7,
  ...r8,
  ...r9,
  ...r10,
  ...r11,
  ...r12,
  ...r13,
};

export default bundle;
